import {usePerson} from "@betrue/front/services";
import {Person} from "@betrue/shared/interfaces";
import {useEffect} from "react";
import {makeVar} from "@apollo/client";
import {useKeycloak} from "@react-keycloak/web";

export const principal = makeVar(null)

export const usePrincipal = (): [Person] => {
  const {keycloak} = useKeycloak()
  const [currentPerson, {current}] = usePerson<Person>(principal)
  useEffect(() => {
    if (!currentPerson && keycloak.idToken) {
      current()
    }

  }, [currentPerson, keycloak.idToken])
  return [currentPerson]
}
